import { MediatailorInitializationData, MediatailorMetadata, MediatailorSession } from '../fl-ads-mediatailor';
import { PALConfiguration } from '@quickplay/pal';
import { Logger } from '@quickplay/foundation';
import { Player, AdPlaybackPolicy } from '@quickplay/player-interface';
import { createClientMediatailorSession } from './DatazoomMediatailor/ClientMediatailorSession';
import { createServerMediatailorSession } from './Mediatailor/ServerMediatailorSession';
import { AdFrequencyControlConfiguration } from '@quickplay/player';

export function createMediatailorSession(): MediatailorSession {
  let impl: MediatailorSession;

  return {
    initialize: async (initData: MediatailorInitializationData, palConfig?: PALConfiguration) => {
      if (!initData.mediatailorSessionConfiguration?.configId) {
        impl = createServerMediatailorSession();
      } else {
        impl = createClientMediatailorSession();
      }

      return impl.initialize(initData, palConfig);
    },

    createMediatailorPlayer: (
      player: Player,
      mediatailorMetadata?: MediatailorMetadata,
      adPlaybackPolicy?: AdPlaybackPolicy,
      logger?: Logger,
      videoElement?: HTMLVideoElement,
      adFrequencyControl?: AdFrequencyControlConfiguration,
    ) => {
      return impl.createMediatailorPlayer(
        player,
        mediatailorMetadata,
        adPlaybackPolicy,
        logger,
        videoElement,
        adFrequencyControl,
      );
    },
  };
}
